import { Button } from '@folio/components';
import {
  useBrokerageFirmControllerGenerateDocumentsForSignature,
  useBrokerageFirmControllerGenerateSignatureRequest,
} from 'korint-sdk';
import { useTranslation } from 'react-i18next';

interface DistributionRequestListApproveButtonProps {
  /**
   * The brokerage firm id.
   */
  brokerageFirmId: string;

  /**
   * The number of waiting for signature distribution requests.
   */
  waitingForSignatureDistributionRequestsNumber: number;
}

export function DistributionRequestListSendForSignatureButton({
  brokerageFirmId,
  waitingForSignatureDistributionRequestsNumber,
}: DistributionRequestListApproveButtonProps) {
  const { t } = useTranslation();

  const {
    mutateAsync: generateDocumentsForSignature,
    isPending: isGenerateDocumentsForSignatureLoading,
  } = useBrokerageFirmControllerGenerateDocumentsForSignature();

  const {
    mutateAsync: brokerageFirmControllerGenerateSignatureRequest,
    isPending: isGenerateSignatureRequestLoading,
  } = useBrokerageFirmControllerGenerateSignatureRequest();

  return (
    <Button
      loading={isGenerateDocumentsForSignatureLoading || isGenerateSignatureRequestLoading}
      onClick={async () => {
        const { ids: documentIds } = await generateDocumentsForSignature({
          brokerageFirmId,
          params: { documentTypes: ['DISTRIBUTION_CONTRACT'] },
        });

        if (documentIds.length > 0) {
          await brokerageFirmControllerGenerateSignatureRequest({
            brokerageFirmId,
            data: {
              deliveryMode: 'EMAIL',
            },
          });
        }
      }}
      variant="default"
    >
      {t('distributionRequestList.sendForSignatureButton.label', {
        count: waitingForSignatureDistributionRequestsNumber,
      })}
    </Button>
  );
}
